/**
 * The thread-index WINDOW constants — a Firebase-free leaf (2026-09-22).
 *
 * These live apart from `chatThreadIndexRepository` on purpose. The store reads
 * `WORKING_SET_LIMIT` to decide whether a snapshot came back SATURATED, and a
 * saturated window is the only thing that makes a thread's absence from it
 * meaningless rather than fatal. Several suites replace the repository module
 * wholesale with `jest.mock`, and a factory that forgets one export hands the
 * store `undefined` — which reads as "this 2-row snapshot is full", the exact
 * wrong direction, silently. A leaf nobody mocks cannot be erased that way, and
 * the harness can model the real window by importing the same number.
 */

/**
 * The live working set: the newest N unarchived threads by `lastActiveAt`, per
 * stream. Everything older exists only behind `loadOlderThreads`.
 */
export const WORKING_SET_LIMIT = 40;

/**
 * One page of `loadOlderThreads`. The caller decides "that was the last page"
 * from `items.length < pageSize`, so a second spelling of this number would
 * mean "exhausted" on a full page.
 */
export const THREAD_PAGE_SIZE = 25;
